const PEM_LINE_WIDTH = 64;

const CHUNK_SIZE = 32_768;

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';

  for (let index = 0; index < bytes.length; index += CHUNK_SIZE) {
    const chunk = bytes.subarray(index, index + CHUNK_SIZE);
    binary += String.fromCodePoint(...chunk);
  }

  return btoa(binary);
}

export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.codePointAt(index) ?? 0;
  }

  return bytes.buffer;
}

export function wrapPem(label: string, base64Body: string): string {
  const lines: string[] = [];

  for (let index = 0; index < base64Body.length; index += PEM_LINE_WIDTH) {
    lines.push(base64Body.slice(index, index + PEM_LINE_WIDTH));
  }

  return `-----BEGIN ${label}-----\n${lines.join('\n')}\n-----END ${label}-----`;
}

export function unwrapPem(pem: string): string {
  return pem
    .replaceAll(/-----BEGIN [^-]+-----/g, '')
    .replaceAll(/-----END [^-]+-----/g, '')
    .replaceAll(/\s+/g, '');
}

export function getWebCrypto(): Crypto {
  const cryptoApi = globalThis.crypto as Crypto | undefined;

  if (cryptoApi?.subtle === undefined) {
    throw new Error('WebCrypto is not available in this environment');
  }

  return cryptoApi;
}
